/**
 * RecurringEventUpdateDialog
 *
 * Prompts user to choose scope when modifying a recurring event:
 * "This event only" or "This and future events".
 */

import { Alert } from 'react-native';

export type RecurringEventScope = 'this' | 'future';

export class RecurringEventUpdateDialog {
  /**
   * Prompt user for update scope on a recurring event.
   * Returns 'this', 'future', or null if cancelled.
   */
  static prompt(): Promise<RecurringEventScope | null> {
    return new Promise((resolve) => {
      Alert.alert(
        'Edit Recurring Event',
        'Do you want to change this event only or this and all future events?',
        [
          { text: 'Cancel', style: 'cancel', onPress: () => resolve(null) },
          { text: 'This event only', onPress: () => resolve('this') },
          { text: 'This and future events', onPress: () => resolve('future') },
        ],
      );
    });
  }

  /**
   * Prompt user for delete scope on a recurring event.
   * Returns 'this', 'future', or null if cancelled.
   */
  static promptDelete(): Promise<RecurringEventScope | null> {
    return new Promise((resolve) => {
      Alert.alert(
        'Delete Recurring Event',
        'Do you want to delete this event only or this and all future events?',
        [
          { text: 'Cancel', style: 'cancel', onPress: () => resolve(null) },
          { text: 'This event only', style: 'destructive', onPress: () => resolve('this') },
          { text: 'This and future events', style: 'destructive', onPress: () => resolve('future') },
        ],
      );
    });
  }
}
